import React, { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

function TextAlertsEditor({ onDirtyChange }) {
  const [settings, setSettings] = useState(null);
  const [savedSnap, setSavedSnap] = useState('');
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getDoc(doc(db, 'settings', 'site'))
      .then((snap) => {
        if (cancelled) return;
        const data = snap.exists() ? snap.data() : {};
        const s = {
          smsEnabled: !!data.smsEnabled,
          smsNumber: data.smsNumber || '',
          smsKeyword: data.smsKeyword || '',
        };
        setSettings(s);
        setSavedSnap(JSON.stringify(s));
      })
      .catch((err) => {
        console.error(err);
        if (cancelled) return;
        const s = { smsEnabled: false, smsNumber: '', smsKeyword: '' };
        setSettings(s);
        setSavedSnap(JSON.stringify(s));
        setStatus('Could not load settings — check your connection.');
      });
    return () => { cancelled = true; };
  }, []);

  const dirty = !!settings && JSON.stringify(settings) !== savedSnap;
  useEffect(() => { if (onDirtyChange) onDirtyChange(dirty); }, [dirty, onDirtyChange]);

  const save = async () => {
    setSaving(true);
    setStatus('');
    try {
      const clean = {
        smsEnabled: settings.smsEnabled,
        smsNumber: settings.smsNumber.trim(),
        smsKeyword: settings.smsKeyword.trim(),
      };
      await setDoc(doc(db, 'settings', 'site'), clean, { merge: true });
      setSettings(clean);
      setSavedSnap(JSON.stringify(clean));
      setStatus('Settings saved.');
    } catch (err) {
      console.error(err);
      setStatus('Save failed — try again.');
    }
    setSaving(false);
  };

  if (!settings) {
    return <div className="schedule-loading"><div className="schedule-spinner" /></div>;
  }

  return (
    <div className="admin-card">
      <h3>TEXT ALERTS SECTION</h3>
      <p className="admin-help">Controls the &quot;Get Text Alerts&quot; box on the Find Us page.</p>
      <label className="admin-closed-toggle">
        <input
          type="checkbox"
          checked={settings.smsEnabled}
          onChange={(e) => setSettings({ ...settings, smsEnabled: e.target.checked })}
        />
        Show &quot;Get Text Alerts&quot; on the site
      </label>
      <input
        type="text"
        placeholder="Text number (e.g. 55678)"
        value={settings.smsNumber}
        onChange={(e) => setSettings({ ...settings, smsNumber: e.target.value })}
      />
      <input
        type="text"
        placeholder="Keyword (e.g. GROUNDED)"
        value={settings.smsKeyword}
        onChange={(e) => setSettings({ ...settings, smsKeyword: e.target.value })}
      />
      <button className="cta-button admin-full-btn" onClick={save} disabled={saving || !dirty}>
        {saving ? 'Saving...' : dirty ? 'Save Settings' : 'Saved'}
      </button>
      {dirty && <p className="admin-unsaved">Unsaved changes</p>}
      {status && <p className="admin-status">{status}</p>}
    </div>
  );
}

export default TextAlertsEditor;
